import React from 'react';

const Layout = React.lazy(() => import('./Layout'));
const DefaultPage = React.lazy(() => import('./DefaultPage'));

export default {
  path: '/:channel/mood-journal',
  name: 'Mood journal',
  component: Layout,
  protected: true,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/mood-journal/route.js